import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

import EventBus from './EventBus';

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
            path: '/',
            name: 'home',
            component: Home,
        },
        {
            path: '/authentication',
            name: 'authentication',
            component: () => import( /* webpackChunkName: "authentication" */ './views/Authentication.vue'),
        },
        {
            path: '/addresses',
            name: 'addresses',
            component: () => import( /* webpackChunkName: "addresses" */ './views/Addresses.vue'),
            beforeEnter: (to, from, next) => {
                EventBus.$emit('ForceLogInUser');
                next();
            },
        },
        {
            path: '/clinics',
            name: 'clinics',
            component: () => import( /* webpackChunkName: "clinics" */ './views/Clinics.vue'),
            beforeEnter: (to, from, next) => {
                EventBus.$emit('ForceLogInUser');
                next();
            },
        },
        {
            path: '/cases',
            name: 'cases',
            component: () => import( /* webpackChunkName: "cases" */ './views/Cases.vue'),
            beforeEnter: (to, from, next) => {
                EventBus.$emit('ForceLogInUser');
                next();
            },
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: () => import( /* webpackChunkName: "privacy" */ './views/Privacy.vue'),
        },
        {
            path: '/terms-of-service',
            name: 'terms-of-service',
            component: () => import( /* webpackChunkName: "terms-of-service" */ './views/TermsOfService.vue'),
        },
    ],
});
